import { Button, Paper, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import styles from "./CISOSubmissionComplete.module.scss";

const CISOSubmissionComplete = () => {
  const navigate = useNavigate();
  const { orgId } = useParams();

  const handleBackToSelect = () => {
    navigate(`/rubiintel/${orgId}/ocis`);
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <img
          src="/service-logos/CISO-Logo.png"
          alt="CISO Logo"
          className={styles.cisoLogo}
        />
        <Typography variant="h4" className={styles.title}>
          Ontario Criminal Intelligence System (OCIS)
        </Typography>
      </div>

      <Paper elevation={3} className={styles.completionCard}>
        <Typography variant="h5" className={styles.successTitle}>
          Submission Completed Successfully
        </Typography>

        <div className={styles.content}>
          <Typography variant="body1" className={styles.description}>
            Thank you for your submission. Your report has been received.
          </Typography>

          <Button
            variant="contained"
            onClick={handleBackToSelect}
            className={styles.backButton}
            size="large"
          >
            Back to Report Selection
          </Button>
        </div>
      </Paper>
    </div>
  );
};

export default CISOSubmissionComplete;
